import { render, staticRenderFns } from "./CustomerWillDeliverDocumentation.vue?vue&type=template&id=4bac7d2c&scoped=true&"
import script from "./CustomerWillDeliverDocumentation.vue?vue&type=script&lang=js&"
export * from "./CustomerWillDeliverDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./CustomerWillDeliverDocumentation.vue?vue&type=style&index=0&id=4bac7d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac7d2c",
  null
  
)

export default component.exports